import {Component, inject, input} from '@angular/core';
import {LucideAngularModule} from 'lucide-angular';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {map, Observable} from 'rxjs';
import {ReactiveFormsModule} from '@angular/forms';
import {
  AutocompleteSelectFieldComponent
} from '@shared/form/choice/autocomplete-select-field/autocomplete-select-field.component';
import {Choice} from '@shared/form/choice/choice';
import {PlaceDTO, PlaceRank} from '@domain/place/place.dto';
import {PlacePipe} from '@domain/place/pipe/place.pipe';
import {PlaceRegionPipe} from '@domain/place/pipe/place-region.pipe';
import {PlaceApi} from '@domain/place/place.api';
import {PlaceUtil} from '@domain/place/place.util';

@Component({
  selector: 'app-place-field',
  imports: [
    LucideAngularModule,
    ReactiveFormsModule,
    AutocompleteSelectFieldComponent
  ],
  providers: [
    PlacePipe,
    PlaceRegionPipe
  ],
  templateUrl: './place-field.component.html',
  styleUrl: './place-field.component.scss'
})
export class PlaceFieldComponent extends FieldBaseComponent<PlaceDTO | null> {

  private readonly placePipe = inject(PlacePipe);
  private readonly placeRegionPipe = inject(PlaceRegionPipe);
  private readonly placeApi = inject(PlaceApi);

  public readonly rank = input<PlaceRank | null>(null);

  public readonly choiceProvider: (term: string) => Observable<Choice<Partial<PlaceDTO>>[]> = (term) => {
    return this.placeApi.search(term, this.rank()).pipe(
      map(places => places.map(place => ({
        value: place ?? null,
        text: this.getPlaceLabel(place) ?? '',
        icon: PlaceUtil.ICONS[place.rank],
        hint: place.rank
      })))
    );
  }

  private getPlaceLabel(place: PlaceDTO | null): string | null {
    let str = this.placePipe.transform(place);
    if (!str) {
      return null;
    }
    const region = this.placeRegionPipe.transform(place);
    if (region) {
      str += `, ${region.code}`;
    }
    return str;
  }

// {{ p | place }}
// @if (p | placeRegion; as region) {
//   <b>{{ region.code }}</b>
// }

  public readonly valueLabel: (value: PlaceDTO) => string | null = (place) => {
    return this.getPlaceLabel(place);
  }
}
